import type { ReactNode } from "react";

interface ConfigPanelLayoutProps {
  form: ReactNode;
  preview: ReactNode;
}

/**
 * Two-panel layout shared by Plot and Table configurators.
 * Left panel holds the form; right panel holds the live preview.
 */
export function ConfigPanelLayout({ form, preview }: ConfigPanelLayoutProps) {
  return (
    <div className="awm-configure-body">
      <div className="awm-left-panel">{form}</div>
      <div className="awm-right-panel">{preview}</div>
    </div>
  );
}
